// src/context/AuthContext.js
import { createContext, useState, useContext } from 'react';
import { useCookies } from 'react-cookie';

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  /* cookies we care about */
  const [cookies, setCookie, removeCookie] = useCookies([
    'lastName',
    'userBadgeId',
    'role',            // "admin" | "user"
  ]);

  /* bootstrap state from cookies */
  const [user, setUser] = useState(() => {
    if (cookies.lastName && cookies.userBadgeId) {
      return {
        lastName: cookies.lastName,
        badge: cookies.userBadgeId,
        role: cookies.role ?? 'user',
      };
    }
    return null;
  });

  /* ---------- helpers ---------- */

  const persistLogin = (lastName, badge, role, opts) => {
    setCookie('lastName',    lastName, opts);
    setCookie('userBadgeId', badge,    opts);
    setCookie('role',        role,     opts);
    setUser({ lastName, badge, role });
  };

  /** regular user login */
  const loginUser = (lastName, badge, opts) =>
    persistLogin(lastName, badge, 'user', opts);

  /** admin login */
  const loginAdmin = (lastName, badge, opts) =>
    persistLogin(lastName, badge, 'admin', opts);

  const logout = () => {
    ['lastName', 'userBadgeId', 'role'].forEach(removeCookie);
    setUser(null);
  };

  /* ---------- derived flags ---------- */

  const isAuthenticated = !!user;
  const isAdmin = user?.role === 'admin';

  /* ---------- context value ---------- */

  const value = {
    user,
    isAuthenticated,
    isAdmin,
    loginUser,
    loginAdmin,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
  );
}
